import React from 'react';
import moment from 'moment';
export const AuthoringStatusBuilder = (reportData) => {

    let reportSections = [];

    const sortConditions = () => {
        reportData.conditions.sort((a, b) => {
            const aString = `${a.name} ${typeof a.version === 'string' ? a.version : '---'}`.toLowerCase();
            const bString = `${b.name} ${typeof b.version === 'string' ? b.version : '---'}`.toLowerCase();
            return aString.localeCompare(bString);
        });
    }


    const buildPublicHealthAgencyDetails = () => {
        let section = [];
        section.push(<div className="section-header" key="pha-details">Public Health Agency Details</div>);
        section.push(
            <div className="data-row" key="pha-name">
                <div className="header one-fourth">PHA Name:</div>
                <div className="three-fourths">{reportData.jurisdiction.pha_name}</div>
            </div>
        );
        section.push(
            <div className="data-row" key="pha-type">
                <div className="header one-fourth">PHA Type:</div>
                <div className="three-fourths capitalize">{reportData.jurisdiction.pha_type.toLowerCase()}</div>
            </div>
        );

        // from BusinessScope or from cdsVersion?
        section.push(
            <div className="data-row" key="pha-description">
                <div className="header one-fourth">Description:</div>
                <div className="three-fourths">{reportData.jurisdiction.description}</div>
            </div>
        );
        section.push(
            <div className="data-row" key="pha-id">
                <div className="header one-fourth">PHA ID:</div>
                <div className="three-fourths">{reportData.jurisdiction.pha_id}</div>
            </div>
        );
        section.push(
            <div className="data-row" key="pha-state">
                <div className="header one-fourth">State:</div>
                <div className="three-fourths capitalize">{reportData.jurisdiction.state_name}</div>
            </div>
        );

        section.push(
            <div className="data-row" key="knowledge-module">
                <div className="header one-fourth">Knowledge Module:</div>
                <div className="three-fourths">{reportData.jurisdiction.knowledge_module}</div>
            </div>
        );

        section.push(
            <div className="data-row" key="version">
                <div className="header one-fourth">Published Version:</div>
                <div className="three-fourths">{reportData.jurisdiction.published_version}</div>
            </div>
        );

        return section;

    };

    const buildConditionList = () => {

        if (reportData.conditions.length > 0) {
            let section = [];
            section.push(<div className="section-header" key="condition-list">Condition List</div>);

            for (let condition of reportData.conditions) {
                let conditionSection = [];
                

                conditionSection.push(
                    <div className="data-row" key={`name-${condition.condition_id}`}>
                        <div className="two-fifths header">Condition</div>
                        <div className="three-fifths condition-value">{condition.name}</div>
                    </div>
                );
                conditionSection.push(
                    <div className="data-row" key={`version-${condition.condition_id}`}>
                        <div className="two-fifths header">Version</div>
                        <div className="three-fifths condition-value">{condition.version}</div>
                    </div>
                );
                conditionSection.push(
                    <div className="data-row" key={`status-${condition.condition_id}`}>
                        <div className="two-fifths header">Status</div>
                        <div className="three-fifths capitalize condition-value">{condition.status.replace(/_/g, " ").toLowerCase()}</div>
                    </div>
                );
                conditionSection.push(
                    <div className="data-row" key={`code-${condition.condition_id}`}>
                        <div className="two-fifths header">Code</div>
                        <div className="three-fifths condition-value">{`${condition.condition_code} - ${condition.code_display_name}`}</div>
                    </div>
                );
                if (condition.category_display_name) {
                    conditionSection.push(
                        <div className="data-row" key={`category-${condition.condition_id}`}>
                            <div className="two-fifths header">Category</div>
                            <div className="three-fifths condition-value">{condition.category_display_name}</div>
                        </div>
                    );
                }
                conditionSection.push(
                    <div className="data-row" key={`lastPub-${condition.condition_id}`}>
                        <div className="two-fifths header">Last Published</div>
                        <div className="three-fifth condition-value">{condition.last_published ? moment(condition.last_published).format("MMM Do YYYY") : '---'}</div>
                    </div>
                );
                conditionSection.push(
                    <div className="data-row" key={`nationally-notifiable-${condition.condition_id}`}>
                        <div className="two-fifths header">Nationally Notifiable</div>
                        <div className="three-fifths condition-value">{condition.nationally_notifiable ? "Yes" : "No"}</div>
                    </div>
                );
                conditionSection.push(
                    <div className="data-row" key={`nnc-${condition.condition_id}`}>
                        <div className="two-fifths header">NNC Code</div>
                        <div className="three-fifths condition-value">{condition.nnc_code ? condition.nnc_code : "---"}</div>
                    </div>
                );
                conditionSection.push(
                    <div className="data-row" key={`rcp-${condition.condition_id}`}>
                        <div className="two-fifths header">Report if care is provided in this jurisdiction</div>
                        <div className="three-fifths condition-value">{condition.care_provided ? "Yes" : "No"}</div>
                    </div>
                );
                conditionSection.push(
                    <div className="data-row" key={`rlp-${condition.condition_id}`}>
                        <div className="two-fifths header">Report if lab is located in this jurisdiction</div>
                        <div className="three-fifths condition-value">{condition.lab_performed ? "Yes" : "No"}</div>
                    </div>
                );
                conditionSection.push(
                    <div className="data-row" key={`rpr-${condition.condition_id}`}>
                        <div className="two-fifths header">Report if patient is a resident of this jurisdiction</div>
                        <div className="three-fifths condition-value">{condition.patient_resident ? "Yes" : "No"}</div>
                    </div>
                );
                conditionSection.push(
                    <div className="data-row" key={`assigned-${condition.condition_id}`}>
                        <div className="two-fifths header">Assigned To</div>
                        <div className="three-fifths condition-value">{typeof condition.assignedTo ? condition.assignedTo : '---'}</div>
                    </div>
                );
                if (condition.tbxEnabled === 'Yes') {
                    conditionSection.push(
                        <div className="data-row" key={`assigned-${condition.condition_id}`}>
                            <div className="two-fifths header">Timebox Duration</div>
                            <div
                                className="three-fifths condition-value">{condition.tbxDuration}</div>
                        </div>
                    );
                }

                section.push(<div className="reference-section-details" key={`reference-${condition.condition_id}`}>{conditionSection.map(i => i)}</div>)
            }

            return section;
        }
    };


    const buildZipCodeList = () => {

        if (reportData.zips.length > 0) {
            let section = [];
            section.push(<div className="section-header" key="header">Zip Code List</div>);
            section.push(<div className="section-description" key="section-descr">Zip Codes will only display if authored by a jurisdiction.</div>);

            section.push(
                <div className="data-header" key="data-header">
                    <div className="one-fifth">Zip Code</div>
                    <div className="one-fifth">City</div>
                    <div className="one-fifth">County</div>
                    <div className="one-fifth">State</div>
                </div>
            );

            for (let zipObj of reportData.zips) {
                section.push(
                    <div className="data-row" key={zipObj.zip}>
                        <div
                            className="one-fifth capitalize">{typeof zipObj.zip === 'string' ? zipObj.zip : '---'}</div>
                        <div
                            className="one-fifth capitalize">{typeof zipObj.city === 'string' ? zipObj.city.toLowerCase() : '---'}</div>
                        <div
                            className="one-fifth capitalize">{typeof zipObj.county === 'string' ? zipObj.county.toLowerCase() : '---'}</div>
                        <div
                            className="one-fifth capitalize">{typeof zipObj.state_name === 'string' ? zipObj.state_name : '---'}</div>
                    </div>
                );
            }

            return section;
        }
    };

    const buildUsersDisplay = () => {
        let section = [];
        if (reportData.users.length > 0) {
            section.push(<div className="section-header" key={"user-list"}>User List</div>);
            section.push(
                <div className="data-header" key="header">
                    <div className="header one-third">Username</div>
                    <div className="header one-third">Role</div>
                </div>
            );

            for (let user of reportData.users) {
                section.push(
                    <div className="data-row" key={`user-${user.username}`}>
                        <div className="one-third capitalize">{typeof user.username === 'string' ? user.username : '---'}</div>
                        <div className="one-third capitalize">{typeof user.role === 'string' ? user.role.toLowerCase().replace(/_/g, ' ') : '---'}</div>
                    </div>
                );
            }
        }
        return section;
    };

    const buildContactInfo = () => {
        if (reportData.contacts.length > 0) {
            let section = [];
            for (let contactObj of reportData.contacts) {

                // Old way of handling Agency Types
                // let agencyType = [];
                // if (contactObj.responsibleAgency) {
                //     agencyType.push('Responsible Agency');
                // }
                // if (contactObj.routingEntity) {
                //     agencyType.push('Routing Entity');
                // }
                // if (contactObj.rulesAuthoringAgency) {
                //     agencyType.push('Rules Authoring Agency');
                // }
                // let subsection = [];
                // section.push(<div className="section-header">Contact Information</div>);
                //
                // subsection.push(
                //     <div className="data-row">
                //         <div className="one-third">Agency Type:</div>
                //         <div className="one-third">{agencyType.join(', ')}</div>
                //     </div>
                // );
                let agencyTypes = contactObj.type.split(', ');
                for (let agencyType of agencyTypes) {
                    let subsection = [];
                    subsection.push(<div className="section-header" key="contact">Contact Information</div>);

                    subsection.push(
                        <div className="data-row" key="type">
                            <div className="header one-third">Agency Type:</div>
                            <div className="two-third">{agencyType}</div>
                        </div>
                    );
                    subsection.push(
                        <div className="data-row" key="descr">
                            <div className="header one-third">Description:</div>
                            <div className="two-third">{contactObj.description}</div>
                        </div>
                    );
                    subsection.push(
                        <div className="data-row" key="street">
                            <div className="header one-third">Street Address:</div>
                            <div className="two-third">{contactObj.address}</div>
                        </div>
                    );
                    subsection.push(
                        <div className="data-row" key="city">
                            <div className="header one-third">City:</div>
                            <div className="two-third">{contactObj.city}</div>
                        </div>
                    );
                    subsection.push(
                        <div className="data-row" key="zip">
                            <div className="header one-third">Zip Code:</div>
                            <div className="two-third">{contactObj.zip_code}</div>
                        </div>
                    );
                    subsection.push(
                        <div className="data-row" key="phone">
                            <div className="header one-third">Phone Number:</div>
                            <div className="two-third">{contactObj.phone}</div>
                        </div>
                    );
                    subsection.push(
                        <div className="data-row" key="email">
                            <div className="header one-third">Email:</div>
                            <div className="two-third">{contactObj.email}</div>
                        </div>
                    );
                    subsection.push(
                        <div className="data-row" key="fax">
                            <div className="header one-third">Fax:</div>
                            <div className="two-third">{contactObj.fax}</div>
                        </div>
                    );

                    section.push(<div className="subsection" key={`contact-${agencyType}-${contactObj.description}`}>{subsection.map(i => i)}</div>);
                }
            }
            return section;
        }
    };

    // NOTE: Removed from build calls by request 
    const buildResponsibleAgencyList = () => {

        if (reportData.conditions.length > 0) {
            let section = [];
            section.push(<div className="section-header" key="resp-agency">Responsible Agency List</div>);

            section.push(
                <div className="data-header" key="data-header">
                    <div className="one-half" style={{ marginRight: '1.5rem' }}>Condition, Version Name</div>
                    <div className="one-half">Responsible Agency</div>
                </div>
            );

            for (let condition of reportData.conditions) {
                section.push(
                    <div className="data-row" key={`condition-${condition.uuid}`}>
                        <div className="one-half" style={{ marginRight: '1.5rem' }}>
                            {condition.conditionDTO.name},{' '}
                            {typeof condition.conditionDTO.version === 'string'
                                ? condition.conditionDTO.version
                                : '---'}
                        </div>
                        <div className="one-half">
                            {condition.conditionDTO.responsibleAgencies.map((v) => v.displayName).join(', ')}
                        </div>
                    </div>
                );
            }

            return section;
        }
    };

    const buildExternalLinksTables = () => {
        if (Object.keys(reportData.references).length > 0) {
            let section = [];
            section.push(<div className="section-header" key="ext-ref">External Links and References</div>);

            //sort 

            for (let [condition, references] of Object.entries(reportData.references)) {
                let subsection = [];

                subsection.push(
                    <div className="subsection-header" key={`condition-ref-${condition}`}>
                        {condition}
                    </div>
                );

                let table = [];

                for (let reference of references) {
                    let referenceSection = [];

                    referenceSection.push(
                        <div className="data-row" key="name">
                            <div className="one-fifth header">Name</div>
                            <div className="four-fifths">{reference.name}</div>
                        </div>
                    );
                    referenceSection.push(
                        <div className="data-row" key="type">
                            <div className="one-fifth header">Type</div>
                            <div className="four-fifths">External</div>
                        </div>
                    );
                    referenceSection.push(
                        <div className="data-row" key="description">
                            <div className="one-fifth header">Description</div>
                            <div className="four-fifths">{reference.description}</div>
                        </div>
                    );
                    referenceSection.push(
                        <div className="data-row" key="url">
                            <div className="one-fifth header">URL</div>
                            <div className="four-fifths"><a href={reference.url}>{reference.url}</a></div>
                        </div>
                    );
                    referenceSection.push(
                        <div className="data-row" key="priority">
                            <div className="one-fifth header">Priority</div>
                            <div className="four-fifths capitalize">{typeof reference.url_priority == 'string' ? reference.url_priority.toLowerCase().replace(/_/g, ' ') : '---'}</div>
                        </div>
                    );
                    referenceSection.push(
                        <div className="data-row" key="category">
                            <div className="one-fifth header">Category</div>
                            <div className="four-fifths capitalize">{typeof reference.url_category == 'string' ? reference.url_category.toLowerCase().replace(/_/g, ' ').replace('addl', 'additional') : '---'}</div>
                        </div>
                    );

                    table.push(<div className="reference-section-details" key={reference.reference_id}>{referenceSection.map(i => i)}</div>)
                }
                subsection.push(<div className="" key={`condition-ref-section-${condition}`}>{table.map(i => i)}</div>);
                section.push(<div className="reference-section" key={`condition-ref-${condition}`}>{subsection.map(i => i)}</div>)

            }
            return section;
        }
    };

    const build = () => {
        sortConditions();
        let report = [];
        report.push(buildPublicHealthAgencyDetails());
        report.push(buildConditionList());
        report.push(buildZipCodeList());
        report.push(buildUsersDisplay());
        report.push(buildContactInfo());
        report.push(buildExternalLinksTables());

        return report;
    };

    return {
        build
    }
};

export default AuthoringStatusBuilder;
